export default __webpack_public_path__ + "static/media/logo-hysterolap.a0c823cd.jpg";